import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded'
(function() {
    // wait for DOM
    window.addEventListener('DOMContentLoaded', () => {
        // just allow one masonry for each site
        const elem = document.querySelector('.set-preview-posts > .posts-container');
        if (elem) {
            // init masonry
            const masonry = new Masonry(elem, {
                itemSelector: '.card',
                columnWidth: '.card',
                gutter: ".gutter-sizer",
                percentPosition: true
            });
            // be sure we render. Call explicit
            masonry.layout();
            imagesLoaded( elem, () => {
                masonry.layout();
            });
        }
    });
})()

